import ElCheckbox from './src/checkbox';

/* istanbul ignore next */
ElCheckbox.install = function(Vue) {
  Vue.component(ElCheckbox.name, ElCheckbox);
};

export default ElCheckbox;



//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/packages/checkbox/index.js
// module id = null
// module chunks = 